export const getSettingsPlanningData = ({ settingsPlanning }) =>
  settingsPlanning.planning;
export const getSettingsPlanningLoading = ({ settingsPlanning }) =>
  settingsPlanning.loaders.common;
export const getError = ({ settingsPlanning }) => settingsPlanning.errors.error;
export const getSuccessEdit = ({ settingsPlanning }) =>
  settingsPlanning.success.edit;
